import { createSlice, current, type PayloadAction } from '@reduxjs/toolkit'

import { countFilterItems } from '../lib/countFilterItems'
import { findCurrentOption } from '../lib/findCurrentOption'

import type { ICatalogState } from './catalogTypes'
import type { TEditableFilterPayload, TFilterOption } from './filterTypes'

const initialState: ICatalogState = {
    filter: [],
    filterCount: 0,
    editableFilter: [],
    editableFilterCount: 0,
    applyOnFilterSelect: true,
    updateUrl: false
}

export const catalogSlice = createSlice({
    name: 'catalog',
    initialState,
    reducers: {
        // Filter

        initializeFilter: (
            state,
            { payload }: PayloadAction<{ filterData: TFilterOption[]; catalogParams: string[] }>
        ) => {
            const decodedParams = payload.catalogParams?.map(str => decodeURIComponent(str))

            const initialData = payload.filterData.map(({ title, items }) => {
                const existingItems = state.editableFilter.find(f => f.title === title)?.items || []

                const newItems = items.filter(item => decodedParams?.includes(item.value))

                return { title, items: [...existingItems, ...newItems] }
            })

            state.filter = initialData
            state.filterCount = countFilterItems(state.filter)
            state.editableFilter = initialData
            state.editableFilterCount = countFilterItems(state.editableFilter)
        },

        applyFilter: state => {
            state.filter = state.editableFilter
            state.filterCount = countFilterItems(state.filter)
            state.editableFilterCount = 0

            // catalogSlice.caseReducers.updateQuery(state)
        },

        resetFilter: state => {
            state.filter = []
            state.filterCount = 0
            state.editableFilter = []
            state.editableFilterCount = 0
            // catalogSlice.caseReducers.updateQuery(state)
        },

        addEditableFilter: (state, { payload }: PayloadAction<TEditableFilterPayload>) => {
            //

            if (payload.config.updateUrl === 'replace') {
                catalogSlice.caseReducers.setUpdateUrl(state, {
                    payload: payload.item.value,
                    type: 'catalog/setUpdateUrl'
                })

                return
            }

            //

            const currentOption = findCurrentOption(state, payload)

            //

            if (!currentOption) return

            //

            state.editableFilter[state.editableFilter.indexOf(currentOption)].items.push(payload.item)

            //

            state.editableFilterCount++

            // catalogSlice.caseReducers.applyFilter(state)

            // if (state.applyOnFilterSelect) catalogSlice.caseReducers.updateQuery(state)
        },

        removeEditableFilter: (state, { payload }: PayloadAction<TEditableFilterPayload>) => {
            if (payload.config.updateUrl === 'replace') {
                catalogSlice.caseReducers.setUpdateUrl(state, {
                    payload: 'catalog',
                    type: 'catalog/setUpdateUrl'
                })

                return
            }

            const currentOption = findCurrentOption(state, payload)

            if (!currentOption) return

            const filteredItems = state.editableFilter[state.editableFilter.indexOf(currentOption)].items.filter(
                item => item.title !== payload.item.title
            )

            state.editableFilter[state.editableFilter.indexOf(currentOption)].items = filteredItems

            state.editableFilterCount--

            // if (state.applyOnFilterSelect) catalogSlice.caseReducers.updateQuery(state)
        },

        setUpdateUrl: (state, { payload }: PayloadAction<string | false>) => {
            state.updateUrl = payload
        }

        //

        //     addEditableFilter: (state, action: PayloadAction<FilterPayload>) => {
        //         catalogSlice.caseReducers.setFilters(state, action)
        //         const { value, key } = action.payload
        //         ;(state.editableFilter[key] as string[]).push(value)
        //         state.editableFilterCount = countFilterValues(state.editableFilter)
        //     },
        //     removeEditableFilter: (state, action: PayloadAction<FilterPayload>) => {
        //         catalogSlice.caseReducers.setFilters(state, action)
        //         const { value, key } = action.payload
        //         state.editableFilter[key] = (state.editableFilter[key] as string[]).filter(item => item !== value)
        //         state.editableFilterCount = countFilterValues(state.editableFilter)
        //     },
        //     applyFilter: state => {
        //         state.filter = state.editableFilter
        //         state.filterCount = countFilterValues(state.filter)
        //         state.editableFilterCount = 0
        //         catalogSlice.caseReducers.updateQuery(state)
        //     },

        //     resetFilter: state => {
        //         const filter = state.filter
        //         const editableFilter = state.editableFilter
        //         Object.keys(filter).forEach(key => {
        //             if (Array.isArray(filter[key])) {
        //                 editableFilter[key] = (editableFilter[key] as string[]).filter(
        //                     item => !(filter[key] as string[]).includes(item)
        //                 )
        //             } else {
        //             }
        //         })
        //         state.editableFilter = editableFilter
        //         state.filter = initialState.filter
        //         state.filterCount = 0
        //         state.editableFilterCount = countFilterValues(editableFilter)
        //         state.query = `${state.pathname}/catalog&category=${state.category}&page=1${
        //             state.sortBy ? `&sortBy=${state.sortBy.value}` : ''
        //         }#catalog`
        //         state.mayReload = true
        //     },
        //     initializeFilters: (
        //         state,
        //         {
        //             payload: { paramsFilters, filtersData }
        //         }: PayloadAction<{ paramsFilters: TParamsFiltersData; filtersData: TFiltersData }>
        //     ) => {
        //         Object.keys(paramsFilters).forEach(key => {
        //             const config = filterConfig(key)
        //             if (!config) return
        //             switch (config?.type) {
        //                 case 'numbers':
        //                     const { maxId } = config
        //                     state.filter[key] = {
        //                         value: paramsFilters[key][0],
        //                         ...(filtersData[key] as TNumbersFilter)
        //                     }
        //                     state.editableFilter[key] = {
        //                         value: paramsFilters[key][0],
        //                         ...(filtersData[key] as TNumbersFilter),
        //                         editableCountAdded: false
        //                     }
        //                     state.filter[maxId!] = {
        //                         value: paramsFilters[maxId!][0],
        //                         ...(filtersData[maxId!] as TNumbersFilter)
        //                     }
        //                     state.editableFilter[maxId!] = {
        //                         value: paramsFilters[maxId!][0],
        //                         ...(filtersData[maxId!] as TNumbersFilter),
        //                         editableCountAdded: false
        //                     }
        //                     break
        //                 default:
        //                     state.filter[key] = paramsFilters[key]
        //                     state.editableFilter[key] = paramsFilters[key]
        //                     break
        //             }
        //         })
        //         state.filterCount = countFilterValues(state.filter)
        //     },
        //     setFilters: (
        //         state,
        //         {
        //             payload: { key, type, numbersFilterData }
        //         }: PayloadAction<{ key: string; type: TFilterType; numbersFilterData?: TNumbersFilter }>
        //     ) => {
        //         if (state.editableFilter[key] !== undefined) return
        //         switch (type) {
        //             case 'numbers':
        //                 state.filter[key] = { value: undefined, ...numbersFilterData! }
        //                 state.editableFilter[key] = { value: undefined, ...numbersFilterData!, editableCountAdded: false }
        //                 break
        //             case 'checkbox':
        //             case 'btns':
        //                 state.filter[key] = []
        //                 state.editableFilter[key] = []
        //                 break
        //         }
        //     },

        //     handleNumbersEditableFilter: (
        //         state,
        //         {
        //             payload: { value, key, numbersFilterData }
        //         }: PayloadAction<{ value: string; key: string; numbersFilterData: TNumbersFilter }>
        //     ) => {
        //         catalogSlice.caseReducers.setFilters(state, {
        //             payload: { key, numbersFilterData, type: 'numbers' },
        //             type: ''
        //         })
        //         if (value === (state.filter[key] as TCatalogNumbersFilter).value) {
        //             state.editableFilterCount--
        //             ;(state.editableFilter[key] as TCatalogNumbersFilter).editableCountAdded = false
        //         } else if (!(state.editableFilter[key] as TCatalogNumbersFilter).editableCountAdded) {
        //             state.editableFilterCount++
        //             ;(state.editableFilter[key] as TCatalogNumbersFilter).editableCountAdded = true
        //         }
        //         ;(state.editableFilter[key] as TCatalogNumbersFilter).value = value
        //     },

        //     setCurrentPage: (state, { payload }: PayloadAction<number>) => {
        //         state.query = `${state.pathname}/catalog&category=${state.category}&page=${payload}${
        //             state.sortBy ? `&sortBy=${state.sortBy.value}` : ''
        //         }#catalog`
        //         state.mayReload = true
        //     },
        //     setCategory: (state, { payload }: PayloadAction<TCatalogCategory>) => {
        //         state.category = payload
        //     },
        //     setSortBy: (state, { payload }: PayloadAction<TCatalogSortBy>) => {
        //         state.sortBy = payload
        //         catalogSlice.caseReducers.updateQuery(state)
        //     },
        //     updateQuery: state => {
        //         const filters: string[] = []
        //         const filter = state.filter
        //         Object.keys(filter).forEach(key => {
        //             if (Array.isArray(filter[key]))
        //                 filter[key].forEach(val => {
        //                     filters.push(`&${key}=${val}`)
        //                 })
        //             else {
        //                 const { value } = filter[key]
        //                 if (value) filters.push(`&${key}=${value}`)
        //             }
        //         })
        //         state.query = `${state.pathname}/catalog&category=${state.category}&page=1${
        //             state.sortBy ? `&sortBy=${state.sortBy.value}` : ''
        //         }${filters.join('') || ''}#catalog`
        //         state.mayReload = true
        //     },
        //     setPathname: (state, { payload }: PayloadAction<string>) => {
        //         state.pathname = payload.split('/catalog')[0]
        //     },
        //     setMayReload: (state, { payload }: PayloadAction<boolean>) => {
        //         state.mayReload = payload
        //     }
    }
})

export const {
    // initializeFilters,
    // addEditableFilter,
    // removeEditableFilter,
    // handleNumbersEditableFilter,
    // applyFilter,
    // resetFilter,
    // setCurrentPage,
    // setCategory,
    // setPathname,
    // setSortBy,
    // updateQuery,
    // setMayReload
    initializeFilter,
    applyFilter,
    resetFilter,
    addEditableFilter,
    removeEditableFilter,
    setUpdateUrl
} = catalogSlice.actions

export default catalogSlice.reducer
